import { format } from 'date-fns';
import { v4 as uuid } from 'uuid';

export async function pushDatalayer(datalayer = {}) {
    let userId = sessionStorage.getItem('user_id');
    if (!userId) {
        const newUserId = uuid();
        sessionStorage.setItem('user_id', newUserId);
        userId = newUserId;
    }

    let datalayerData = {
        ...datalayer,
        ...(datalayer.event === 'page' ? {
            timestamp: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
            environment: (window?.environment || '')?.toLocaleLowerCase(),
            page_layout: window.matchMedia('(min-width: 768px)').matches ? 'desktop' : 'mobile',
            platform: 'web',
            user_id: userId
        } : {}),
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(datalayerData);
}

export function appendPageDatalayer(datalayer = {}, awaitEvent) {
    window.pageDataLayer = window.pageDataLayer || [];
    window.pageDataLayer.push(datalayer);

    if (awaitEvent) {
        window.dispatchEvent(new Event(awaitEvent));
    }
}
